import { FETCH_USER, KEEP_USER } from '../actions/types';
const initialState = { key: '', name: '', userId: '', isAuth: false }
export default function (state, action) {
    state = state || initialState;
    switch(action.type) 
    {
        case FETCH_USER:
            return action.payload;
        case KEEP_USER:
            return action.payload;
        default:
            return state;
    }
}